import { RemoteOptions } from "@/models/FormBuilderModel";
import { prop } from "vue-class-component";

export class LookupHandlerProps {
    lookupName?: RemoteOptions = prop({ required: false });
    selectedValue?: string = prop({ required: false });
    multiselectValue?: any[] = prop({ required: false });
}